<template>
  <div>
    <app-notification :title="title"
                      :text="text"
                      :notification-buttons="notificationButtons"
                      :footer-button="footerButton"
                      :icon-type="'danger'"/>
  </div>
</template>

<script>
import Intercom from '@/Intercom';
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow.vue';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';

export default {
  name: 'OutOfDateNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('OutOfDateNotificationShown');
    Segment.trackUserInteraction('JustInTimeCX_Shown', { source: this.$options.name });
  },
  computed: {
    ...mapState('credentials', ['credentialsList']),
    footerButton() {
      return {
        title: 'לצ׳אט עם הצוות',
        variant: 'flat-black',
        size: 'slim',
        action: this.handleIntercomClickAction,
        // eslint-disable-next-line global-require
        icon: require('@/assets/icons/chat_icon_teriatry.svg'),
        id: 'cx-just-in-time-tech-error-footer-button',
      };
    },
    title() {
      if (this.obkFailedSource) {
        return `יש תקלה בבנק ${this.obkFailedSource.sourceName} ולכן התזרים לא יכול להתעדכן.`;
      }
      return 'אנחנו מתנצלים, יש לנו תקלה טכנית';
    },
    text() {
      if (this.obkFailedSource) {
        return `מומלץ לחבר את החשבון עם פרטי ההתחברות הקבועים שלך ל${this.obkFailedSource.sourceName}.`;
      }
      return 'הצוות שלנו עובד כדי לתקן אותה מהר! נשלח לך לינק לתזרים מעודכן ברגע שהיא תיפתר.';
    },
    obkFailedSource() {
      return _.find(this.credentialsList, { status: 'obkSourceFailure' });
    },
    notificationButtons() {
      if (this.obkFailedSource) {
        return [{
          title: 'לחיבור החשבון עם סיסמה',
          action: this.handleReconnectSourceClickAction,
          id: 'cx-just-in-time-tech-error-reconnect-source-button',
        }];
      }
      return [];
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    ...mapActions('credentials', ['deleteCredentials']),
    handleIntercomClickAction() {
      Segment.trackUserInteraction('JustInTimeCX_Clicked', { source: this.$options.name });
      Intercom.showNewMessage('');
    },
    handleReconnectSourceClickAction() {
      Segment.trackUserInteraction('ReconnectSourceWithPasswordFromNotificationClicked', { source: this.obkFailedSource.sourceName });
      this.deleteCredentials({ credentialsId: this.obkFailedSource.credentialsId });
      this.openModal({
        component: AddCredentialsFlow,
        props: {
          preventOBkConnection: true,
          sourceNameToAdd: this.obkFailedSource.sourceName,
        },
        popupAlignment: 'full-screen',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
